import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface WindowFrameProps {
    children: ReactNode
    title?: string
    tone?: 'light' | 'dark'
    actions?: ReactNode
    className?: string
    bodyClassName?: string
}

export const WindowFrame: FC<WindowFrameProps> = ({
    children,
    title,
    tone = 'light',
    actions,
    className,
    bodyClassName
}): ReactNode => {
    const dark = tone === 'dark'

    return (
        <div
            className={cn(
                'overflow-hidden rounded-2xl border shadow-2xl',
                dark ? 'border-background/10 bg-foreground text-background shadow-foreground/25' : 'border-border bg-card text-card-foreground shadow-foreground/10',
                className
            )}
        >
            <div className={cn('flex items-center gap-3 border-b px-4 py-2.5', dark ? 'border-background/10' : 'border-border bg-muted/70')}>
                <div className='flex shrink-0 gap-1.5' aria-hidden='true'>
                    <span className='size-2.5 rounded-full bg-red-400' />
                    <span className='size-2.5 rounded-full bg-amber-400' />
                    <span className='size-2.5 rounded-full bg-emerald-400' />
                </div>

                {title && (
                    <p className={cn('min-w-0 truncate font-mono text-[11px]', dark ? 'text-background/55' : 'text-muted-foreground')}>
                        {title}
                    </p>
                )}

                {actions && (
                    <div className='ml-auto flex shrink-0 items-center gap-2'>
                        {actions}
                    </div>
                )}
            </div>

            <div className={bodyClassName}>
                {children}
            </div>
        </div>
    )
}
